<template>
  <!-- Modal Template with Transition -->
  <transition
    name="slide-down"
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 translate-y-[-10px]"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition-all duration-300 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-[-10px]"
  >
    <div
      v-if="isOpen"
      class="absolute inset-0 font-poppins z-50 mt-16 md:mt-[80px] lg:mt-[75px]"
      @click.self="closeModal"
    >
      <div class="mr-0 sm:mr-0 md:mr-3 lg:mr-3">
        <div
          class="flex justify-center sm:justify-center md:justify-end lg:justify-end w-full h-full"
        >
          <div class="bg-white rounded-xl text-[13px] p-5 shadow-lg">
            <div class="flex justify-end cursor-pointer h-5 items-center">
              <div
                @click="closeModal"
                class="p-2 rounded-full hover:bg-green-200 transition-colors"
              >
                <icon name="close" />
              </div>
            </div>

            <div class="w-[300px] md:w-[350px] lg:w-[275px]">
              <div class="flex flex-col justify-center items-center space-y-2">
                <div>
                  <!-- Users Image  -->
                  <div class="flex justify-center">
                    <img :src="logoUrl" alt="Logo" class="w-[70px]" />
                  </div>
                  <h1 class="text-[17px] text-gray-700 mb-2">
                    Hi, {{ formData.firstname }}
                  </h1>
                </div>
                <!-- <router-link to="/user/personal-info">
                  <div
                    class="border border-green-700 text-green-800 rounded-full p-3 py-2 px-7 tracking-widest text-[11px] md:text-[13px]"
                  >
                    <h1>Manage Portal Account</h1>
                  </div></router-link
                >  -->
              </div>
            </div>
            <!-- Account Content -->
            <div>
              <div class="space-y-1 mt-2">
                <div
                  class="flex justify-start bg-gray-100 hover:bg-gray-200 px-3 py-3 w-auto md:w-full rounded-t-xl cursor-pointer gap-2"
                >
                  Account
                </div>
                <div>
                  <div v-if="userdetail">
                    <div
                      class="flex flex-col p-2 bg-gray-100 hover:bg-gray-200 rounded-md"
                    >
                      <div
                        class="flex flex-row items-center justify-between gap-5 md:gap-10"
                      >
                        <div
                          class="flex flex-row gap-3 text-[11px] md:text-[13px] px-1"
                        >
                          <!-- <img :src="logoUrl" alt="Logo" class="w-10" /> -->
                          <div>
                            <p class="font-medium">
                              {{ formData.firstname }}
                              {{ userdetail.middlename }}
                              {{ userdetail.lastname }}
                            </p>
                            <p class="text-gray-500">{{ formData.email }}</p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="flex justify-center mt-4 gap-5 font-light tracking-wider"
                      >
                        <router-link to="/user/personal-info">
                          <div
                            class="border border-green-700 text-green-800 rounded-full p-3 py-2 px-7 tracking-widest text-[11px] md:text-[13px]"
                          >
                            <h1>Manage Account</h1>
                          </div></router-link
                        >
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div
                      class="flex flex-col p-2 bg-gray-100 hover:bg-gray-200 rounded-md"
                    >
                      <div class="animate-pulse flex space-x-4">
                        <div class="rounded-full bg-slate-700 h-10 w-10"></div>
                        <div class="flex-1 space-y-6 py-1">
                          <div class="space-y-3">
                            <div class="h-2 bg-slate-700 rounded"></div>
                            <div class="h-2 bg-slate-700 rounded"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="py-2 flex flex-row items-center justify-center gap-1 mt-1 bg-gray-100 hover:bg-gray-200 rounded-b-xl cursor-pointer"
                    @click="toggleSignout"
                  >
                    <Icon :name="'logout'" />
                    <p class="text-textblack1 text-[11px] md:text-[13px]">
                      Signout
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isSignOut"><portalSignoutConfirmation /></div>
    </div>
  </transition>
</template>

<script>
import Icon from "../icon.vue";
import portalSignoutConfirmation from "../alert/portal-signout-confirmation.vue";

export default {
  name: "SettingModalPage",
  components: {
    Icon,
    portalSignoutConfirmation,
  },
  data() {
    return {
      isShowAgree: false,
      isShowMoreVisible: false,
      isShowButton: false,
      visible: false,
      isOpen: true,
      isShowMoreAccounts: false,
      logoUrl: require("../../assets/img/dnsc_logo.png"),
      isSignOut: false,
      userdetail: [],
      formData: this.$store.state.user,
    };
  },
  methods: {
    showMore() {
      this.isShowMoreVisible = !this.isShowMoreVisible;
      if (this.isShowMoreVisible && this.userdetail) {
        this.isShowMoreAccounts = true;
      }
    },
    toggleSignout() {
      this.isSignOut = !this.isSignOut;
      // this.$store.dispatch("setUser", null);
      // this.logout();
    },
    toggleButton() {
      this.isShowButton = !this.isShowButton;
    },
    closeModal() {
      this.isOpen = false;
    },
    closeAgree() {
      this.isShowAgree = false;
      this.isOpen = true;
    },
    showAgree() {
      this.isShowAgree = !this.isShowAgree;
      this.isOpen = false;
    },
  },
  mounted() {
    console.log(this.$store.state.user);
  },
};
</script>

<style scoped>
/* Add any styles here */
</style>
